// extracted by mini-css-extract-plugin
export default {"infoValue":"GlobalInfo_infoValue__9hmnA"};